<div grid-container>
  @for (_ of Array(49); track $index) {
    <button [style]="styleForItem($index+1)" item [class]="classForItem($index+1)" mat-flat-button (click)="onItemClick($index+1)">{{ $index + 1 }}</button>
  }
</div>
<div controls>
  <button (click)="onClearClick()" mat-icon-button>
    <mat-icon>clear all</mat-icon>
  </button>
  <button (click)="onDeleteClick()" mat-icon-button>
    <mat-icon>delete</mat-icon>
  </button>
</div>
